
<div class="bg-surface-100 dark:bg-surface-800 px-6 py-20 md:px-12 lg:px-20">
    <div class="flex flex-col lg:flex-row items-center justify-center">
        <div class="text-center">
            <div class="text-primary font-medium mb-4 text-lg leading-normal">
                TAKE THE NEXT STEP
            </div>

            <div class="text-surface-900 dark:text-surface-0 font-bold text-5xl leading-tight">
                Schedule a demo!
            </div>

            <p class="mb-8">
                Test-drive of all the features and functionality that {{ appName }} has to offer.
            </p>

            <div class="inline-flex items-center">
                <a routerLink="/contact/us" [queryParams]="contactQueryParams" class="no-underline">
                    <button pButton [rounded]="true">
                        <span pButtonLabel>Request Demo</span>
                        <i pButtonIcon class="pi pi-arrow-right"></i>
                    </button>
                </a>
            </div>
        </div>
    </div>
</div>
